import { createTheme } from '@mui/material/styles';

const index = createTheme({
  palette: {
    primary: {
      main: '#0000FF'
    },
    secondary: {
      main: '#061B25'
    },
    neutral: {
      black: '#000000',
      blackLight: '#262626',
      blackLighter: '#434343',
      white: '#FFFFFF',
      whiteDark: '#f5f5f5',
      whiteDarker: '#dedede',
      gray: '#909090',
      grayLight: '#d5d5d5',
      grayDark: '#555555'
    }
  },

  typography: {
    fontFamily: '"MarQ Capital Text", "Nunito Sans", "Manrope", sans-serif',

    TitleXSmall: {
      fontSize: '1.1rem',
      fontWeight: 500
    },
    TitleSmall: {
      fontSize: '1.4rem',
      fontWeight: 700
    },

    // Section Title Variants
    TitleMedium: {
      fontSize: '1.8rem',
      fontWeight: 600
    },

    TitleLarge: {
      fontSize: '2.5rem',
      fontWeight: 600
    },

    TitleXLarge: {
      fontSize: '3.4rem',
      fontWeight: 700
    },

    ParagraphSmall: {
      fontSize: '1.1rem',
      fontWeight: 400,
      color: 'var(--neutral-gray-dark)'
    },

    ParagraphMedium: {
      fontSize: '1.2rem',
      fontWeight: 300,
      color: 'var(--neutral-black)'
    },

    ParagraphSmallBlackBG: {
      color: 'var(--neutral-white)'
    },

    CenteredText: {
      color: 'var(--neutral-white)'
    },

    CenteredTitle: {
      color: 'var(--neutral-white)',
      fontSize: '1.2rem'
    },

    FooterText: {
      fontSize: '0.9rem',
      fontWeight: 400
    },

    FooterTextSmall: {
      fontSize: '0.8rem',
      fontWeight: 400
    }
  },
  spacing: 8,
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '4px',
          textTransform: 'none'
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
          transition: 'transform 0.3s',
          '&:hover': {
            transform: 'translateY(-5px)'
          }
        }
      }
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          backgroundColor: 'transparent',
          boxShadow: 'none'
        }
      }
    }
  }
});

export default index;
